import {
  Component,
  inject,
  signal,
  ViewChild,
} from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import {
  FormsModule,
} from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  BarcodeScannerSearchField,
  CodeScannedEvent,
} from '../../../components/barcode-scanner-search-field/barcode-scanner-search-field';
import { MatIcon } from '../../../components/mat-icon/mat-icon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

export interface BarcodeEditDialogData {
  barcodes?: string[];
}

@Component({
  selector: 'app-internal-barcode-edit-dialog',
  imports: [
    SkeletonModule,
    DialogModule,
    ButtonModule,
    TranslatePipe,
    BarcodeScannerSearchField,
    MatIcon,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    FloatLabelModule,
    FormsModule,
  ],
  providers: [DialogService, TranslateService],
  templateUrl: './barcodeEditDialog.html',
  styleUrl: './barcodeEditDialog.scss',
})
export class BarcodeEditDialog {
  //private dialogService = inject(DialogService);
  private translate = inject(TranslateService);
  //private messageService = inject(MessageService);
  //private router = inject(Router);
  //public api = inject(ApiService);
  //public printer = inject(PrinterService);

  @ViewChild(BarcodeScannerSearchField) search: BarcodeScannerSearchField;

  barcodes = signal<string[]>([]);

  constructor(
    public dialogRef: DynamicDialogRef<BarcodeEditDialog>,
    public config: DynamicDialogConfig<BarcodeEditDialogData>,
  ) {
    config.header = this.translate.translate('internal.inventory.barcodeEdit.title')();

    this.barcodes.set(this.config.data.barcodes || []);
  }

  ngAfterViewInit() {
    this.search.reset();
  }

  codeScanned(code: CodeScannedEvent) {
    this.barcodes.update((b) => [...b, code.code]);
    this.search.reset();
  }

  setBarcodeText(index, text) {
    this.barcodes.update((b) => {
      b[index] = text;
      return [...b];
    });
  }

  removeBarcode(index: number) {
    this.barcodes.update((b) => {
      b.splice(index, 1);
      return [...b];
    });
  }

  save() {
    this.dialogRef.close(this.barcodes());
  }
}
